/*
  Mecca Books footer — accordion toggle for the Shop/Learn/Support/About
  link columns on mobile. At desktop widths the toggle button is made
  non-interactive by CSS (pointer-events: none, panel forced visible),
  so this click handler simply never fires there — no matchMedia guard
  needed on the JS side.
*/
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.mb-footer__col-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var col = btn.closest('.mb-footer__col--links');
        if (!col) return;
        var isOpen = col.classList.toggle('mb-footer__col--open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  });
})();
